import React from 'react';

export default ({ children, isLoading }) => {
    return (<label>{children}{isLoading && <div className="spinner-border text-primary" role="status" style={{ height: "1rem", width: "1rem" }} ><span className="sr-only">Chargement...</span> </div>}</label>)
}